import {createContext, useContext} from 'react';
import type {
  FinancialConnectionsSessionResult,
  CollectBankAccountTokenResult,
} from '@stripe/stripe-js';
import type {Locale} from '@sail/intl';

export type CollectFinancialConnectionsAccountsOverride = (options: {
  clientSecret: string;
  locale: Locale;
  merchantId?: string;
  publishableKey?: string;
  stripeJsEndpoint: string;
}) => Promise<FinancialConnectionsSessionResult>;

export type CollectBankAccountTokenOverride = (options: {
  clientSecret: string;
  locale: Locale;
  merchantId?: string;
  publishableKey?: string;
  stripeJsEndpoint: string;
}) => Promise<CollectBankAccountTokenResult>;

type FinancialConnectionsOverrideValue = {
  collectFinancialConnectionsAccounts: CollectFinancialConnectionsAccountsOverride | null;
  collectBankAccountToken: CollectBankAccountTokenOverride | null;
};

const FinancialConnectionsOverrideContext =
  createContext<FinancialConnectionsOverrideValue>({
    collectFinancialConnectionsAccounts: null,
    collectBankAccountToken: null,
  });

export const FinancialConnectionsOverrideProvider =
  FinancialConnectionsOverrideContext.Provider;

export const useFinancialConnectionsOverrideContext = () =>
  useContext(FinancialConnectionsOverrideContext);
